<script setup>
import Switch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  icon: { type: String, default: '' },
  iconClass: { type: String, default: 'bg-n-iris-3 text-n-iris-11' },
  toggleable: { type: Boolean, default: false },
});

const enabled = defineModel('enabled', { type: Boolean, default: true });
</script>

<template>
  <section class="border rounded-xl border-n-weak bg-n-solid-1 shadow-sm">
    <header class="flex items-start gap-3 px-5 py-4">
      <span
        v-if="icon"
        class="grid flex-shrink-0 rounded-lg size-9 place-items-center"
        :class="iconClass"
      >
        <span class="size-[18px]" :class="icon" />
      </span>
      <div class="flex flex-col flex-1 min-w-0 gap-0.5">
        <h3 class="m-0 text-base font-semibold text-n-slate-12">{{ title }}</h3>
        <p v-if="description" class="m-0 text-sm text-n-slate-11">
          {{ description }}
        </p>
      </div>
      <slot name="actions" />
      <Switch v-if="toggleable" v-model="enabled" class="mt-1.5" />
    </header>
    <div
      v-if="$slots.default"
      class="px-5 pb-5 transition-opacity"
      :class="{ 'opacity-50 pointer-events-none': toggleable && !enabled }"
    >
      <slot />
    </div>
  </section>
</template>
